import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import BrandMarquee from "@/components/BrandMarquee";
import Manifesto from "@/components/Manifesto";
import Divisions from "@/components/Divisions";
import StoreNetwork from "@/components/StoreNetwork";
import MoodOffers from "@/components/MoodOffers";
import Legacy from "@/components/Legacy";
import Testimonials from "@/components/Testimonials";
import BlogSection from "@/components/BlogSection";
import Newsletter from "@/components/Newsletter";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";

export default function Home() {
  useEffect(() => {
    const hash = window.location.hash?.replace("#", "");
    if (hash) {
      const scroll = () => {
        if (window.__lenis) window.__lenis.scrollTo(`#${hash}`, { offset: -70 });
        else document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
      };
      setTimeout(scroll, 400);
    }
  }, []);

  return (
    <main className="relative bg-konattu-cream" data-testid="home-page">
      <Seo description="Konattu Group is Kerala's trusted retail group since 1998, with 17 stores for home appliances, furniture, hypermarkets, crockery and Emilia beauty. Your Quality Shopping Partner." path="/" />
      <Navbar />
      <Hero />
      <BrandMarquee />
      <Manifesto />
      <Divisions />
      <StoreNetwork />
      <MoodOffers />
      <Legacy />
      <Testimonials />
      <BlogSection />
      <Newsletter />
      <Contact />
      <Footer />
    </main>
  );
}
